let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VZbR")).then(() => parcelRequire('4Na6w'));